import { BuilderElementType } from '@website-builder/model/domain/builder-element-type.enum';
import { HeaderStyle } from '@website-builder/model/structure/header/header-style';
import { EditableComponent } from '@website-builder/model/structure/editable-component.interface';
import { HeaderSection } from '@website-builder/model/structure/section/header-section';
import { BuilderElementPosition } from '@website-builder/model/structure/builder-element-position';
import { TbUtility } from '@website-builder/util/tb-utility';
import { BuilderRootStructureType } from '@website-builder/model/state/builder-root-structure.type';

export class Header implements EditableComponent {
  readonly type: BuilderRootStructureType = BuilderElementType.Header;
  builderElementPosition: BuilderElementPosition;
  id = TbUtility.randomIdAsNumber;
  title = '';
  previewUrl = 'assets/images/no-preview-available.jpg';
  sections: HeaderSection[] = new Array<HeaderSection>();
  style = new HeaderStyle();

  static normalizeInPlace(header: Partial<Header>): Header {
    const pureHeader = new Header();

    header.id = header.id ?? pureHeader.id;
    header.title = header.title ?? pureHeader.title;
    header.previewUrl = header.previewUrl ?? pureHeader.previewUrl;
    header.sections = (header.sections ?? []).map(section => HeaderSection.normalizeInPlace(section));
    header.style = HeaderStyle.normalize(header.style);

    return header as Header;
  }
}
